import { ActionTree } from 'vuex';
import { AuthenticationParameters, AuthState } from '@/modules/Auth/store/state';
import { RootState } from '@/plugins/store';
import { AuthAction, AuthActionTypes } from '@/modules/Auth/store/actions-types';
import LoginService from '@/modules/Login/services/LoginService';
import { AUTH } from '@/modules/Auth/store/mutation-types';
import LoginResponse from '@/models/LoginResponse';
import { ERROR } from '@/modules/ErrorToaster/store/mutation-types';
import jwtDecode from 'jwt-decode';
import ErrorManager from '@/common/utils/ErrorManager';

export const actions: ActionTree<AuthState, RootState> = {
    async [AuthAction.POST_LOGIN]({ commit }: AuthActionTypes, data: AuthenticationParameters): Promise<string> {
        commit(AUTH.SET_LOADING, true);

        return new Promise((resolve, reject) => {
            LoginService.signIn(data)
                .then(async response => {
                    if (response !== undefined || response?.status !== undefined) {
                        if (response.status !== 200) {
                            commit(`errorToaster/${ERROR.SET_MESSAGE}`, response.data.message, { root: true });
                            reject();
                        }
                        const user: LoginResponse = jwtDecode(response.data.token);
                        if (!user.email_azure && !data.password) {
                            commit(AUTH.SET_IS_OLD_LOGIN, true);
                        } else {
                            localStorage.setItem('token_portail_partenaire', response.data.token);
                            localStorage.token = response.data.token;
                            //on sauvegarde le jwt
                            commit(AUTH.SET_TOKEN, response.data.token);
                            commit(AUTH.SET_USER_INFORMATIONS, jwtDecode(response.data.token));
                            //on decode le jwt pour récupérer les informations du user
                            localStorage.setItem('login', user.sub);
                            localStorage.setItem('nom', user.nom);
                            localStorage.setItem('prenom', user.prenom);
                            localStorage.setItem('email', user.email_azure ?? user.email ?? '');                            localStorage.setItem('isClient', user.isClient.toString());
                            localStorage.setItem('isFournisseur', user.isFournisseur.toString());
                        }
                        resolve(response.data.b2cPolicy);
                    } else {
                        commit(`errorToaster/${ERROR.SET_MESSAGE}`, response.data.message, { root: true });
                        resolve('');
                    }
                })
                .catch(async error => {
                    commit(`errorToaster/${ERROR.SET_MESSAGE}`, error.response.data.message, { root: true });
                }) .finally(() => {
                commit(AUTH.SET_LOADING, false);
            });
        });
    },
    async [AuthAction.VERIFIER_LOGIN]({ commit }: AuthActionTypes, data: AuthenticationParameters): Promise<string> {
        commit(AUTH.SET_LOADING, true);
        return new Promise(resolve => {
            LoginService.verifierLogin(data)
                .then(async response => {
                    if (response !== undefined || response?.status !== undefined) {
                        if (response.data.loginExist && !data.password) {
                            commit(AUTH.SET_IS_OLD_LOGIN, true);
                        }
                        if (response.data.emailAzure) {
                            commit(AUTH.SET_EMAIL_AZURE, response.data.emailAzure);
                        }
                        resolve(response.data.b2cPolicy);
                    } else {
                        console.error('Error during login:');

                        commit(`errorToaster/${ERROR.SET_MESSAGE}`, response?.data.message, { root: true });
                    }
                })
                .catch(async error => {
                    console.error('Error during login:', error);
                    commit(`errorToaster/${ERROR.SET_MESSAGE}`, ErrorManager.processError(error), { root: true });
                })
                .finally(() => {
                    commit(AUTH.SET_LOADING, false);
                });
        });
    },
};
